import React from 'react';
import { withRouter } from 'react-router-dom';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {Modals} from "../../component";
import {deleteCase, cancelCase} from "../../vendors/actions/case";

interface OwnProps {

}

interface ConnectStateProps {
}

interface ConnectDispatchProps {
    deleteCase: (case_uid: string) => void,
    cancelCase: (data: any) => void,
}

const CancelCase = (props: any) => {
    const {Modals: ModalActions} = props;
    const {cancelCase} = ModalActions;
    const split = window.location.pathname.split('/');
    const case_uid = split[split.length - 1];
    const title: any = <span>Are you sure you want to delete this case?</span>;
    const caseCancel = () => {
        props.deleteCase(case_uid);
        props.cancelCase(false);
    };

    const cancelCaseModal = () => {
        props.cancelCase(false);
    };

    return cancelCase ? (
        <Modals.Danger title={title}
                       open={cancelCase}
                       cancelable={{
                           buttonTitle: 'Never Mind',
                           action: cancelCaseModal
                       }}
                       submit={{
                           buttonTitle: 'Delete',
                           action: caseCancel
                       }}
                       icon={'times'}
                       mainBtnColor='secondary'
                       secondaryBtnColor='secondary'
                       description=''/>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Modals} = state;
    return {
        Modals,
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        deleteCase: (case_uid: string) => dispatch(deleteCase(case_uid)),
        cancelCase: (data: any) => dispatch(cancelCase(data)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CancelCase));


